export default __webpack_public_path__ + "static/media/iago.fdc2a5f0.png";